// extracted by mini-css-extract-plugin
module.exports = {"notification":"zv2Bj","icon":"_3ZozE","link":"_1XoQA"};